
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stayIntroduction",
      function () {
        return require("private-next-pages/stayIntroduction/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stayIntroduction"])
      });
    }
  